import React from "react";
import styled from "styled-components";
import { RiChat1Line } from "react-icons/ri";
import { AiOutlinePhone } from "react-icons/ai";
import { AiOutlineFileText } from "react-icons/ai";
import { useTranslation } from "react-i18next";
const StyledAiOutlinePhone = styled(AiOutlinePhone)`
  font-size: 30px;
  flex-shrink: 0;
  color: #1a2b4b !important;
`;

const StyledRiChat1Line = styled(RiChat1Line)`
  font-size: 30px;
  flex-shrink: 0;
  color: #1a2b4b !important;
`;

const StyledAiOutlineFileText = styled(AiOutlineFileText)`
  font-size: 30px;
  flex-shrink: 0;
  color: #1a2b4b !important;
`;

const BoxWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 15px;
  column-gap: 10px;

  @media (min-width: 576px) {
    column-gap: 15px;
  }

  @media (min-width: 768px) {
    column-gap: 20px;
  }

  @media (min-width: 992px) {
    justify-content: center;
  }
`;

const Box = styled.a`
  width: 100%;
  display: block;
  padding: 12px 24px;
  background-color: #ffb6b9;
  border-radius: 20px;
  box-shadow: 0 5px 10px rgba(32, 64, 110, 0.1), ,
    0 2px 3px rgba(32, 64, 110, 0.2);

  &:hover {
    background-color: #ff848a;
    color: #ffffff;
    transition: background-color 0.2s ease-in-out;
  }

  @media (min-width: 576px) {
    width: 48%;
  }

  @media (min-width: 992px) {
    width: 25%;
    padding: 24px 30px;
  }
`;

const BoxContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const Heading = styled.div`
  font-size: 16px;
  color: #1a2b4b !important;
  font-weight: 700;
  @media (min-width: 768px) {
    font-size: 18px;
  }
`;

const SubHeading = styled.div`
  font-size: 12px;
  color: #1a2b4b !important;
  overflow-wrap: break-word;

  @media (min-width: 768px) {
    font-size: 14px;
  }
`;

const ATLTinkerpreneurGuidelines = (props) => {
  const { t } = useTranslation();
  const { year } = props;

  // TODO: update the FAQs and helpline email as per the event

  return (
    <BoxWrapper>
      <Box href={`/assets/pdf/ai-for-educators-faqs.pdf`} target="_blank">
        <BoxContent>
          <StyledRiChat1Line />
          <Heading>{t("frequently_asked_questions")}</Heading>
        </BoxContent>
      </Box>
      <Box>
        <BoxContent>
          <StyledAiOutlinePhone />
          <Heading style={{ lineHeight: "22px" }}>{t("helpline")}</Heading>
          <SubHeading style={{ marginTop: "15px", fontWeight: "bold" }}>
            <a
              href="mailto:swayamplus.aiforeducators@gmail.com"
              style={{ color: "#1A2B4B" }}
            >
              swayamplus.aiforeducators@gmail.com
            </a>
            <br />
            <span style={{ fontSize: "13px" }}>{t("helpline_text")}</span>
          </SubHeading>
        </BoxContent>
      </Box>
      {/* <Box href={`/assets/pdf/tinkerpreneur-2025-flyer.pdf`} target="_blank">
        <BoxContent>
          <StyledAiOutlineFileText />
          <Heading>{t("atl_tinkerpreneur.flyer_text")}</Heading>
          <SubHeading style={{ marginTop: "15px", fontWeight: "bold" }}>
            {t("donwload_here_text")}
          </SubHeading>
        </BoxContent>
      </Box> */}
    </BoxWrapper>
  );
};

export default ATLTinkerpreneurGuidelines;
